<html>
  <head>
    <title>Peak Rapor</title>
  </head>
  <body id="parentdiv">
    <div class="main-title mb-3">
      <div class="print-process-button">
        <div class="row">
          <div class="col-3">
            <label class="container-checkbox">
              <span>Yeni Sayfa</span>
              <input autocomplete="off" type="checkbox" id="txt_form_AddUser_UserIsActive" name="UserIsActive"
                  class="form-check-input" [(ngModel)]="isNewPage">
              <span class="checkmark"></span>
          </label>
          </div>
          <div class="col-6">
            <!-- <button class="btn tablo-new-button btn-process" (click)="htmltoPDF()">pdf</button> -->
            <button class="btn tablo-new-button btn-process" (click)="print()">Yazdır</button>
            <button class="btn tablo-new-button btn-process" (click)="isVisibleDescriptionModal = true">Yeni</button>
            <!-- <button class="btn tablo-new-button btn-process" style="width: auto;" (click)="createTemplate()">Şablonu Kaydet</button> -->
          </div>
          <div class="col-3"></div>
        </div>
      </div>
    </div>
    <div class="A4">
      <div class="header">
        <div class="header-title">
          <img class="print-header-img" src="/assets/img/peak-gelisim-logo.png">
        </div>
      </div>
      <div class="content content-body">
        <div class="content">
          <img class="peak-img" src="../../../../assets/img/peak_bigimage.png">
        </div>
        <div class="content content-company">
          <img style="width: 25%;"  [src]="studentModel.CompanyPhoto | companyPhoto">
        </div>
        <div class="content content-company">
          <h4>{{studentModel.CompanyName}}</h4>
          <h5>{{trainingModel.FullName}}</h5>
          <h5>{{getDateOnlyString(classModel.StartDate)}}</h5>
          <h5>{{trainingModel.TrainingName}}</h5>
        </div>
        <div class="content content-company" style="margin-top: 6rem;">
          <h5>{{studentModel.FirstName + ' ' + studentModel.LastName}}</h5>
          <h6>{{studentModel.TCIdentityNumber}}</h6>
          <h6>{{studentModel.StudentDepartment}}</h6>
        </div>
      </div>
      <div class="footer">
        <div class="footer-title">
          <img class="print-header-img" src="/assets/img/peak-gelisim-logo.png">
        </div>
      </div>
    </div>
    <div class="A4" *ngIf="isNewPage">
      <div class="header">
        <div class="header-title">
          <img class="print-header-img" src="/assets/img/peak-gelisim-logo.png">
        </div>
      </div>
      <div class="content content-body">
        <div class="print-page" *ngFor="let item of reportDescription" >
          <div class="print-title action-click" (click)="showUpdateModal(item.id)">
            <h5>{{item.title}}</h5>
          </div>
          <div class="print-desc" style="margin: 10px 40px 0px 40px;">
            <div [innerHTML]="item.description | trustHtml"></div>
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="footer-title">
          <img class="print-header-img" src="/assets/img/peak-gelisim-logo.png">
        </div>
      </div>
    </div>
    <div class="A4">
      <div class="header">
        <div class="header-title">
          <img class="print-header-img" src="/assets/img/peak-gelisim-logo.png">
        </div>
      </div>
      <div class="content content-body">
        <div class="print-page">
          <div class="print-title">
            <h5>DEĞERLENDİRME SONUÇLARI</h5>
          </div>
          <div class="print-desc" style="text-align: center;">
            <div><img [src]="reportImageBase64" style="max-width: 100%;max-height: 35cm;"></div>
          </div>
        </div>
        <div class="print-page" *ngIf="yygReport.length > 0">
          <div class="print-title">
            <h5>Yönetim Yetenekleri Anketi Takım Sonuçları</h5>
          </div>
          <div class="print-desc">
            <table>
              <tr>
                <th>Liderlik</th>
                <th>İşbirliği Sağlama</th>
                <th>Tanıma/Takdir</th>
                <th>Performans Yönetimi</th>
                <th>Etkin Delegasyon</th>
                <th>Çalışanı Geliştirme</th>
                <th>Bağlılık Yaratma</th>
              </tr>
              <tr *ngFor="let participant of yygReport">
                <td>{{participant.liderlik}}</td>
                <td>{{participant.grup_ici}}</td>
                <td>{{participant.takdir}}</td>
                <td>{{participant.performans}}</td>
                <td>{{participant.delegosyan}}</td>
                <td>{{participant.gelistirme}}</td>
                <td>{{participant.yaratma}}</td>
              </tr>
            </table>
          </div>
        </div>
        <ng-container *ngIf="!isNewPage">
          <div class="print-page" *ngFor="let item of reportDescription" style="margin-top: 10px;">
            <div class="print-title action-click" (click)="showUpdateModal(item.id)">
              <h5>{{item.title}}</h5>
            </div>
            <div class="print-desc" style="margin: 10px 40px 0px 40px;">
              <div [innerHTML]="item.description | trustHtml"></div>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="footer">
        <div class="footer-title">
          <img class="print-header-img" src="/assets/img/peak-gelisim-logo.png">
        </div>
      </div>
    </div>
  </body>
</html>

<app-modal [(isVisible)]="isVisibleDescriptionModal">
  <div class="row">
      <div class="col-md-11 center" style="text-align: unset;">
          <h4 class="mb-5 text-center form-text-heading2" style="font-size: 1.5em;margin-bottom: 40px;"><i class="fas fa-user-graduate form-icon-heading" aria-hidden="true"></i>Açıklama Ekle</h4>

          <form class="needs-validation" name="form" (ngSubmit)="f.form.valid && createModel()" #f="ngForm">

            <div class="row mb-3">
              <div class="col-md-12">
                <label class="form-text">Başlık </label>
                <input class="form-control" name="title" [(ngModel)]="Title" autocomplete="off" required>
                <!-- <div *ngIf="f.submitted && Title.invalid" class="invalid-feedback">
                  <div *ngIf="Title.errors.required">Lütfen başlık giriniz.</div>
                </div> -->
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-md-12">
                <label class="form-text">Açıklama </label>
                <ckeditor #editor [config]="EditorConfig" [editor]="Editor" (ready)="onEditorReady($event)" (change)="onEditorChange($event)" 
                    name="AnnouncementDescription" [(ngModel)]="Description"  rows="5" required>
                </ckeditor>
                <!-- <div *ngIf="f.submitted && Description.invalid" class="invalid-feedback">
                  <div *ngIf="Description.errors.required">Lütfen açıklama giriniz.</div>
                </div> -->
              </div>
            </div>

              <div class="center tablo-button">
                  <button type="button" class="btn tablo-edit-button" (click)="cancel()">Kapat</button>
                  <button type="submit" class="btn tablo-new tablo-new-button">Kaydet</button>
              </div>
          </form>


      </div>
  </div>
</app-modal>

<app-modal [(isVisible)]="isVisibleDescriptionUpdateModal">
  <div class="row">
      <div class="col-md-11 center" style="text-align: unset;">
          <h4 class="mb-5 text-center form-text-heading2" style="font-size: 1.5em;margin-bottom: 40px;"><i class="fas fa-user-graduate form-icon-heading" aria-hidden="true"></i>Açıklama Düzenle</h4>

          <form class="needs-validation" name="form" (ngSubmit)="f.form.valid && updateModal()" #g="ngForm">

            <div class="row mb-3">
              <div class="col-md-12">
                <label class="form-text">Başlık </label>
                <input class="form-control" name="title" [(ngModel)]="Title" autocomplete="off" required>
                <!-- <div *ngIf="f.submitted && Title.invalid" class="invalid-feedback">
                  <div *ngIf="Title.errors.required">Lütfen başlık giriniz.</div>
                </div> -->
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-md-12">
                <label class="form-text">Açıklama </label>
                <ckeditor #editor [config]="EditorConfig" [editor]="Editor" (ready)="onEditorReady($event)" (change)="onEditorChange($event)" 
                    name="AnnouncementDescription" [(ngModel)]="Description"  rows="5" required>
                </ckeditor>
                <!-- <div *ngIf="f.submitted && Description.invalid" class="invalid-feedback">
                  <div *ngIf="Description.errors.required">Lütfen açıklama giriniz.</div>
                </div> -->
              </div>
            </div>

              <div class="center tablo-button">
                  <button type="button" class="btn tablo-edit-button" (click)="cancel()">Kapat</button>
                  <button type="button" class="btn tablo-new tablo-edit-button" (click)="deleteModal()">Sil</button>
                  <button type="submit" class="btn tablo-new tablo-new-button">Kaydet</button>
              </div>
          </form>


      </div>
  </div>
</app-modal>
